import React from "react";
import { Link } from "react-router-dom";

function Footer({ handleSectionClick }) {
  const year = new Date().getFullYear();
  return (
    <footer className="clean-footer crev" id="main-footer">
      <div className="container pb-40 pt-40 ontop">
        <div className="row justify-content-between">
          <div className="col-lg-2">
            <div className="logo icon-img-100 md-mb80">
              {/* <img src="/assets/imgs/logo-light.png" alt="" /> */}
              <img src="/assets/imgs/nn-logo.png" alt="logo" style={{width: "50px"}} />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Contact</h6>
              <h6 className="p-color fw-400">Carlisle, PA, United States.</h6>
              <h6 className="mt-30 mb-15">
                <a href="#0"> nithinnamani994@gmail.com</a>
              </h6>
              <a href="#0" className="underline">
                <span className="fz-22 main-color">+1 (717) 567-1773</span>
              </a>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Useful Links</h6>
              <ul className="rest fz-14 opacity-7">
                <li className="mb-15" onClick={() => handleSectionClick(1)}>
                  <Link to="/home">About Me</Link>
                </li>
                <li className="mb-15" onClick={() => handleSectionClick(2)}>
                  <Link to="/home">Case Studies</Link>
                </li>
                <li className="mb-15" onClick={() => handleSectionClick(3)}>
                  <Link to="/home">Articles</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="column subscribe-minimal">
              <h6 className="sub-title mb-30">Newsletter</h6>
              {/* <div className="form-group mb-40">
                <input type="text" name="subscrib" placeholder="Your Email" />
                <button>
                  <span className="ti-location-arrow"></span>
                </button>
              </div> */}
              <ul className="rest social-icon d-flex align-items-center">
                {/* <li className="hover-this cursor-pointer">
                  <a href="#0" className="hover-anim">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li className="hover-this cursor-pointer ml-10">
                  <a href="#0" className="hover-anim">
                    <i className="fab fa-dribbble"></i>
                  </a>
                </li> */}
                <li className="hover-this cursor-pointer ml-10">
                  <a
                    href="https://www.linkedin.com/in/nithin-chandra-namani-640043227/"
                    className="hover-anim"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </li>
                {/* <li className="hover-this cursor-pointer ml-10">
                  <a href="#0" className="hover-anim">
                    <i className="fab fa-instagram"></i>
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-30 pb-30 mt-80 bord-thin-top">
          <div className="text-center">
            <p className="fz-14">Nithin Namani © {year}</p>
          </div>
        </div>
      </div>
      <div className="circle-blur">
        <img src="/assets/imgs/patterns/blur1.png" alt="" />
      </div>
    </footer>
  );
}

export default Footer;
